<template>
  <div class="home">
    <p id="yokoplz">
      <img src="@/assets/images/common/tatetoyoko.png" width="100px" alt="" />
    </p>
    <p id="logo_wrap">
      <img
        src="@/assets/images/common/logo-top.png"
        width="460"
        alt="onetoone"
      />
    </p>

    <div id="enter">
      <router-link :to="{ name: 'pages', params: { id: 1 } }">
        <p>ENTER</p>
      </router-link>
    </div>
    <p id="intro">
      ページ右上のメニューからご覧になりたいエリアを選択できます
    </p>

    <p id="icon_dsc">
      <img
        src="@/assets/images/common/icon_dsc.png"
        width="560px"
        alt="icon_dsc"
      />
    </p>
    <div id="top_mov">
      <iframe
        class="mov"
        src="https://www.youtube.com/embed/tukOVkN8VEo"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home'
};
</script>

<style lang="css" src="@/assets/css/import.css"></style>
<style lang="css" src="@/assets/css/iphone.css"></style>
